import {absCenter, panel, colors} from '@xpertdox_js/xdstyle';


export default {
  container: {
    width: '100%',
    minHeight: '100vh',
  },
  content: {
    ...absCenter,
    ...panel,
    padding: '10px 8px 24px',
    textAlign: 'center',
    maxWidth: '424px'
  },
  message: {
    fontSize: '2.4rem',
    margin: '12px auto 38px',
  },
  btn: {
    background: colors.xdHighlight,
    minWidth: '125px',
    color: '#fff',
    borderRadius: '2px',
    display: 'inline-block',
    padding: '12px 18px',
    fontSize: '1.45rem'
  }
}
